// @ts-nocheck
import React, { lazy, Suspense } from "react";

import RouteLoadingIndicator from "../../components/RouteLoadingIndicator/RouteLoadingIndicator";

import LoanFlow from "../LoanFlow/LoanFlow.container";


const LazyContainer = lazy(() =>
  import(/* webpackChunkName: "member-routes" */"./Dashboard.container")
);

const Container =  props =>
  <Suspense
    fallback={<RouteLoadingIndicator />}>
    <LoanFlow>
      <LazyContainer {...props} />
    </LoanFlow>
  </Suspense>;

export default Container;
//export default hot(Container);
